import React from "react";
// import CurrencyFormat from 'react-currency-format'
import { useStateValue } from "./StateProvider";
import { getBasketTotal } from "./reducer";
import "./subtotal.css";

function Subtotal() {
  const [{ basket }, dispatch] = useStateValue();
  console.log(getBasketTotal(basket));
  return (
    <div className="subtotal">
      {/* <CurrencyFormat
              renderText={(value) => (
                  <>
                      <p>
                          Subtotal ({basket.length} items): <strong>{ value }</strong>
                    </p>
                      <small className="subtotal_gift">
                          <input type="checkbox"/> This order contains a gift
                    </small>
                  </>
              )}
              decimalScale={2}
              value = {getBasketTotal(basket)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
          /> */}

      <p>
        Subtotal ({basket.length} items):
        <strong> ${getBasketTotal(basket)}</strong>
      </p>
      <small className="subtotal_gift">
        <input type="checkbox" /> This order contains a gift
      </small>

      <button>Proceed to checkout</button>
    </div>
  );
}

export default Subtotal;
